module.exports = __webpack_public_path__ + "media/add-ons/webinar@2x-2b556080.png";